export default __webpack_public_path__ + "static/media/INMED AI STUDIO final-02-Photoroom.png-Photoroom.fecd2753.png";